export const randomUUID = () => {
    if (globalThis.crypto?.randomUUID) {
        return globalThis.crypto.randomUUID();
    }
    // Fallback for non-secure contexts (e.g. plain HTTP on mobile devices)
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => (+c ^ (globalThis.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16));
};
//# sourceMappingURL=crypto.js.map